import { Box, Typography } from "@mui/material";

import copy from "../../public/locales/en/analytics.json";
import ProductAnalyticsReport from "../components/ProductAnalyticsReport";

import type { ReactElement } from "react";

export default function AnalyticsPage(): ReactElement {
  return (
    <Box>
      <Typography variant="h4">{copy.navigation}</Typography>
      <ProductAnalyticsReport />
    </Box>
  );
}
